/**
 * Grid contenedor para todas las tarjetas de tareas cron
 * Responsive y optimizado
 */
import React, { useMemo } from 'react'
import CronTaskCard from './CronTaskCard'
import CronTaskSkeleton from './CronTaskSkeleton'
import type { CronTaskConfig } from '../../config/cron/cronTasksConfig'
import type { CronTaskStatusData } from '../../types/cron/cronTasks'

interface CronTasksGridProps {
  tasks: CronTaskConfig[]
  tasksData: Array<{
    status: CronTaskStatusData | null
    count: number | null
    isLoading: boolean
    error: string | null
    countdown: {
      hours: number
      minutes: number
      seconds: number
      humanReadable: string
      isExpired: boolean
    }
    onExecute: () => Promise<void>
  }>
  isLoading: boolean
}

const CronTasksGrid: React.FC<CronTasksGridProps> = React.memo(
  ({ tasks, tasksData, isLoading: gridLoading }) => {
    const gridClasses = useMemo(
      () =>
        'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6',
      []
    )

    if (gridLoading && tasksData.length === 0) {
      return (
        <div className={gridClasses}>
          {tasks.map((task) => (
            <CronTaskSkeleton key={task.id} />
          ))}
        </div>
      )
    }

    return (
      <div className={gridClasses}>
        {tasks.map((task, index) => {
          const taskData = tasksData[index]
          if (!taskData) {
            return <CronTaskSkeleton key={task.id} />
          }

          return (
            <CronTaskCard
              key={task.id}
              config={task}
              status={taskData.status}
              count={taskData.count}
              isLoading={taskData.isLoading}
              error={taskData.error}
              countdown={taskData.countdown}
              onExecute={taskData.onExecute}
            />
          )
        })}
      </div>
    )
  }
)

CronTasksGrid.displayName = 'CronTasksGrid'

export default CronTasksGrid

